import {createAction} from '@reduxjs/toolkit';
import {createGeometryObj} from '@app/util/geom';

const actionPrefix = 'SEARCH';

export const saveGeometry = createAction(`${actionPrefix}/SAVE_GEOMETRY`);

export const defineGeometry =
  ({geometry, zoomTo = true, isGeometryTooComplex = false, fromHash = false}) =>
  dispatch => {
    const {newGeometry, geometryTooLarge} = createGeometryObj(geometry);

    dispatch(
      saveGeometry({
        geometry: newGeometry,
        geometryTooLarge,
        geometryZoomTo: zoomTo,
        isGeometryTooComplex,
        fromHash,
      })
    );
  };

export const clearSearch = createAction(`${actionPrefix}/CLEAR_SEARCH`);
